import { v4 as uuid } from 'uuid';

import { WEBCHAT_VISITOR_IDENTIFIER_PREFIX } from 'modules/webchat/domain/constants';
import {
  IWebchatIdentity,
  IWebchatTracking,
} from 'modules/webchat/domain/entities';

import formatPhoneToE164 from './formatPhoneToE164';

type TBuildVisitorWebchatIdentityParams = {
  name: string;
  phone: string;
  countryCode: string;
  tracking?: IWebchatTracking;
};

/**
 * Identidade do visitante que passou pelo pré-chat. O identifier é aleatório
 * e fica só nesta sessão do navegador. Quem identifica a pessoa e cria o lead
 * é o bot da Callbell, pelo celular informado aqui, que também grava no lead
 * a origem capturada no clique.
 */
export default function buildVisitorWebchatIdentity({
  name,
  phone,
  countryCode,
  tracking,
}: TBuildVisitorWebchatIdentityParams): IWebchatIdentity {
  return {
    identifier: `${WEBCHAT_VISITOR_IDENTIFIER_PREFIX}${uuid()}`,
    name: name.trim(),
    phone: formatPhoneToE164(phone, countryCode),
    ...(tracking ? { tracking } : {}),
  };
}
